import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import HomePage from '../pages/HomePage.vue'
import TripsHomePage from '../pages/TripsHomePage.vue'
import EventsHomePage from '../pages/EventsHomePage.vue'
import ForumPage from '../pages/ForumPage.vue'
import ContactsPage from '../pages/ContactsPage.vue'
import NewTrackPage from '../pages/NewTrackPage.vue'
import NewTripPage from '../pages/NewTripPage.vue'
import NewEventPage from '../pages/NewEventPage.vue'
import EditTripPage from '../pages/EditTripPage.vue'
import EditEventPage from '../pages/EditEventPage.vue'
import EditTrackPage from '../pages/EditTrackPage.vue'
import TrackPage from '../pages/TrackPage.vue'
import TripPage from '../pages/TripPage.vue'
import EventPage from '../pages/EventPage.vue'
import ProfilePage from '../pages/ProfilePage.vue'
import NotificationsPage from '../pages/NotificationsPage.vue'
import AuthorPublicTracksPage from '../pages/AuthorPublicTracksPage.vue'
import AuthorPublicTripsPage from '../pages/AuthorPublicTripsPage.vue'
import AuthorPublicEventsPage from '../pages/AuthorPublicEventsPage.vue'
import PublicProfilePage from '../pages/PublicProfilePage.vue'
import LoginPage from '../pages/LoginPage.vue'
import RegisterPage from '../pages/RegisterPage.vue'
import CheckEmailPage from '../pages/CheckEmailPage.vue'
import ConfirmEmailPage from '../pages/ConfirmEmailPage.vue'
import ForgotPasswordPage from '../pages/ForgotPasswordPage.vue'
import ResetPasswordPage from '../pages/ResetPasswordPage.vue'
import AdminLayout from '../pages/admin/AdminLayout.vue'
import AdminUsersPage from '../pages/admin/AdminUsersPage.vue'
import AdminTracksPage from '../pages/admin/AdminTracksPage.vue'
import AdminTripsPage from '../pages/admin/AdminTripsPage.vue'
import AdminCommentsPage from '../pages/admin/AdminCommentsPage.vue'
import AdminModerationActionsPage from '../pages/admin/AdminModerationActionsPage.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: HomePage, meta: { showNavbar: true } },
    { path: '/trips', name: 'trips-home', component: TripsHomePage, meta: { showNavbar: true } },
    { path: '/events', name: 'events-home', component: EventsHomePage, meta: { showNavbar: true } },
    { path: '/forum', name: 'forum', component: ForumPage, meta: { showNavbar: true } },
    { path: '/contacts', name: 'contacts', component: ContactsPage, meta: { showNavbar: true } },
    { path: '/tracks/new', name: 'track-new', component: NewTrackPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/trips/new', name: 'trip-new', component: NewTripPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/events/new', name: 'event-new', component: NewEventPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/trips/:id/edit', name: 'trip-edit', component: EditTripPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/events/:id/edit', name: 'event-edit', component: EditEventPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/tracks/:id/edit', name: 'track-edit', component: EditTrackPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/tracks/:id', name: 'track', component: TrackPage, meta: { showNavbar: true } },
    { path: '/trips/:id', name: 'trip', component: TripPage, meta: { showNavbar: true } },
    { path: '/events/:id', name: 'event', component: EventPage, meta: { showNavbar: true } },
    { path: '/users/:id/tracks', name: 'author-tracks', component: AuthorPublicTracksPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/users/:id/trips', name: 'author-trips', component: AuthorPublicTripsPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/users/:id/events', name: 'author-events', component: AuthorPublicEventsPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/u/:username', name: 'public-profile', component: PublicProfilePage, meta: { showNavbar: true } },
    { path: '/u/:username/tracks', name: 'public-profile-tracks', component: AuthorPublicTracksPage, meta: { showNavbar: true } },
    { path: '/u/:username/trips', name: 'public-profile-trips', component: AuthorPublicTripsPage, meta: { showNavbar: true } },
    { path: '/u/:username/events', name: 'public-profile-events', component: AuthorPublicEventsPage, meta: { showNavbar: true } },
    { path: '/profile', name: 'profile', component: ProfilePage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/notifications', name: 'notifications', component: NotificationsPage, meta: { requiresAuth: true, showNavbar: true } },
    { path: '/login', name: 'login', component: LoginPage, meta: { guest: true } },
    { path: '/register', name: 'register', component: RegisterPage, meta: { guest: true } },
    { path: '/check-email', name: 'check-email', component: CheckEmailPage, meta: { guest: true } },
    { path: '/confirm-email', name: 'confirm-email', component: ConfirmEmailPage, meta: { guest: true } },
    { path: '/forgot-password', name: 'forgot-password', component: ForgotPasswordPage, meta: { guest: true } },
    { path: '/reset-password', name: 'reset-password', component: ResetPasswordPage, meta: { guest: true } },
    {
      path: '/admin',
      component: AdminLayout,
      meta: { requiresAuth: true, requiresAdmin: true, showNavbar: true },
      children: [
        { path: '', redirect: { name: 'admin-users' } },
        { path: 'users', name: 'admin-users', component: AdminUsersPage },
        { path: 'tracks', name: 'admin-tracks', component: AdminTracksPage },
        { path: 'trips', name: 'admin-trips', component: AdminTripsPage },
        { path: 'comments', name: 'admin-comments', component: AdminCommentsPage },
        { path: 'moderation-actions', name: 'admin-moderation-actions', component: AdminModerationActionsPage },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (!auth.checked) {
    await auth.fetchCurrentUser()
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return { name: 'home' }
  }

  if (to.meta.guest && auth.isAuthenticated) {
    return { name: 'home' }
  }

  return true
})

export default router
